import { HotelConfig } from "stores/wizard/config";
import { hotelConfig } from "./hotelConfig";

export const hotelConfigHTG: HotelConfig = {
  ...hotelConfig,
  date: {
    ...hotelConfig.date,
    defaultOffsetDates: {
      start: 30,
      end: 31,
    },
  },
};
